import {
  CUSTOM_SCREEN_FIND_ALL,
  CUSTOM_SCREEN_SET_INITIAL_STATE,
  CUSTOM_SCREEN_VIEW
} from './customScreenTypes'


const initialState = {
  data: [],
  pagination: {
    currentpage: 1,
    itemcount: 0,
    pagesize: 10,
    firstpage: '',
    lastpage: '',
    nextpages: [],
    prevpages: [],
    totalpages: 0
  },

  viewResult: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOM_SCREEN_SET_INITIAL_STATE:
      return initialState;
    case CUSTOM_SCREEN_FIND_ALL:
      return {
        data: action.payload.data,
        pagination: action.payload.pagination
      }
    case CUSTOM_SCREEN_VIEW:
    return {
      ...state,
      viewResult: action.payload.data
    }
    default: return state
  }
}

export default reducer
